import moment from 'moment-timezone';
import {titleCase, ucFirst} from 'change-case';

/**
 * Convert boolean values to text
 *
 * @param value
 * @param trueText
 * @param falseText
 * @returns {string}
 */
const booleanFilter = function (value, trueText, falseText) {
    return value ? trueText || 'Yes' : falseText || 'No';
};

/**
 * Format value into date-time string
 *
 * @param value
 * @returns {string}
 */
const datetimeFilter = function (value) {
    if (value) {
        return moment(String(value)).tz('America/New_York').format('MM/DD/YYYY h:mm A');
    }
};

/**
 * Format value into date-time string
 *
 * @param value
 * @returns {string}
 */
const datetimeNoTZFilter = function (value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY h:mm A');
    }
};

/**
 * Format value into date string
 *
 * @param value
 * @returns {string}
 */
const dateFilter = function (value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY');
    }
};

/**
 * Format value into time string
 *
 * @param value
 * @returns {string}
 */
const timeFilter = function (value) {
    if (value) {
        return moment(String(value)).format('h:mm A');
    }
};

/**
 * Convert value to title case string
 *
 * @param value
 * @returns {string}
 */
const titleCaseFilter = function (value) {
    if(value) {
        return titleCase(value);
    }
};

/**
 * Convert value to uppercase first string
 *
 * @param value
 * @returns {string}
 */
const ucFirstFilter = function (value) {
    if(value) {
        return ucFirst(value);
    }
};

/**
 * Convert value to 2 digit precision number
 *
 * @param value
 * @returns {string}
 */
const toFixed2Filter = function (value) {
    if(value !== null && !Number.isNaN(value)) {
        return Number(value).toFixed(2);
    }
};

/**
 * Convert a truthy value to 2 digit precision number or return null
 *
 * @param value
 * @returns {string|null}
 */
const toFixed2orNullFilter = function (value) {
    if(value && value !== null && !Number.isNaN(value)) {
        return Number(value).toFixed(2);
    }
    return null;
};

const leftpadFilter = function (value, length, string) {
    if(value) {
        return value.toString().padStart(length, string);
    }
};

/**
 * Convert value to currency formatted string
 *
 * @param value
 * @returns {string}
 */
const currencyFilter = function (value) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
};

export default {
    install: function (Vue, options) {
        Vue.filter('boolean', booleanFilter.bind(options));
        Vue.filter('datetime', datetimeFilter.bind(options));
        Vue.filter('datetimeNoTZ', datetimeNoTZFilter.bind(options));
        Vue.filter('date', dateFilter.bind(options));
        Vue.filter('time', timeFilter.bind(options));
        Vue.filter('leftpad', leftpadFilter.bind(options));
        Vue.filter('titleCase', titleCaseFilter.bind(options));
        Vue.filter('ucFirst', ucFirstFilter.bind(options));
        Vue.filter('toFixed2', toFixed2Filter.bind(options));
        Vue.filter('toFixed2orNull', toFixed2orNullFilter.bind(options));
        Vue.filter('currency', currencyFilter.bind(options));
    }
};
